import { NodeViewWrapper, type NodeViewProps } from '@tiptap/react';

import { EntityReferenceChip } from '@/components/ui/EntityReferenceChip';

import type { EntityReference } from '@littlebird/markdown-utils';

export const EntityReferenceNodeView = ({ node, selected }: NodeViewProps) => (
  <NodeViewWrapper as="span" contentEditable={false}>
    <EntityReferenceChip
      reference={node.attrs as EntityReference}
      selected={selected}
    />
  </NodeViewWrapper>
);
